// 모달 z-index 자동 스태킹(antd Modal 파리티).
// 선언형 OmDialog(PlainDialog)와 명령형 confirm(DialogStack)이 하나의 커서를 공유해,
// 나중에 열린 모달이 항상 먼저 열린 모달 위로 뜬다(예: Settings 팝업 위의 SendAsEmailInput).
// 열린 모달이 모두 닫히면 base 로 리셋한다. base/step 은 --om-z-modal(1000) 토큰과 정합.
const Z_BASE = 1000
const Z_STEP = 10
let zCursor = Z_BASE
let openCount = 0

// 모달 오픈 시 acquire/close 시 release 를 1:1 로 호출해야 한다.
// 명시 zIndex 가 있으면 그대로 반환하되 커서를 그 값까지 끌어올려 이후 모달이 항상 위로 뜨게 한다.
export function acquireModalZIndex(explicit?: number): number {
  openCount += 1
  if (explicit != null) {
    zCursor = Math.max(zCursor, explicit)
    return explicit
  }
  zCursor += Z_STEP
  return zCursor
}

export function releaseModalZIndex(): void {
  openCount -= 1
  if (openCount <= 0) {
    openCount = 0
    zCursor = Z_BASE
  }
}
